import Header from '../../../__Layout/Header';
import React from 'react';
import Loader from '../../../utils/Loader';
import { useGetstudentquestionPdfQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import {Link, useParams } from 'react-router-dom';

import { pdfjs } from 'react-pdf';
import { Worker,Viewer } from '@react-pdf-viewer/core';

import '@react-pdf-viewer/core/lib/styles/index.css';

export default function PaidCourseReleventQuestion() {   
    const { lpid,courseId } = useParams();
    const param= 'lpid='+lpid;
    const {
        data: PaidCourseRelevantQuestion,
        isLoading: PaidCourseDetailLoader,
    } = useGetstudentquestionPdfQuery({ pageUrl, params: param });
    pdfjs.GlobalWorkerOptions.workerSrc =  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    if(PaidCourseDetailLoader) return  <Loader></Loader>
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">My Courses/Training Detail Relevant Questions</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training Details</button>
                        </li>
                        <li>
                            <Link to={`/student-course-topic/${courseId}/${lpid}`} className='btn btn-dark pull-right'>
                              Back
                            </Link>
                        </li>
                       
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-12'>
                                   
                                   {PaidCourseRelevantQuestion?.data?.map((item,index) => {      
                                            return (  
                                                    <div className='col-md-12 col-xs-12 col--12 border' key={index}>
                                                     <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                                        <Viewer fileUrl={item.relevant_question_link} />
                                                    </Worker>
                                                 
                                                   </div>                               
                                                 )  
                                        })  
                                        }
                                   </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
